import React from "react";

const SvgWithLabels = ({ company, score }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1353.6 348.8">
    <defs>
      <style>
        {`
          .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 { fill: #fff; }
          .cls-1, .cls-3 {
            font-family: SFPro-Regular, 'SF Pro';
            font-size: 31px;
            font-variation-settings: 'wdth' 100, 'opsz' 28, 'wght' 400;
          }
          .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {
            stroke-miterlimit: 10;
          }
          .cls-7, .cls-10, .cls-12, .cls-13 { fill: none; stroke: #f2f2f2; }
          .cls-8 { fill: #084891; opacity: 0.4; stroke: #fff; }
          .cls-9 { fill: #44adff; opacity: 0.4; stroke: #fff; }
          .cls-14 { fill: #007aff; opacity: 0.4; stroke: #fff; }
          .cls-11 { fill: #0994ff; stroke: #fff; }
          .cls-2 { font-family: SFPro-Medium, 'SF Pro'; font-size: 25px; font-weight: 500; }
          .cls-5, .cls-6 {
            font-family: SFPro-Bold, 'SF Pro';
            font-weight: 700;
          }
          .cls-5 { font-size: 25px; }
          .cls-6 { font-size: 28.71px; }
          .cls-10 { stroke-dasharray: 4.62 4.62; }
          .cls-12 { stroke-dasharray: 4 4; }
          .cls-13 { stroke-dasharray: 4.02 4.02; }
          .cls-15 { opacity: 0.4; }
          .cls-16 { letter-spacing: 0em; }
          .cls-17 { letter-spacing: 0em; }
          .cls-18 { letter-spacing: -.11em; }
          .cls-19 { letter-spacing: -.02em; }
          .cls-20 { letter-spacing: -.01em; }
          .cls-21 { letter-spacing: -.05em; }
          .cls-22 { letter-spacing: -.01em; }
          .cls-23 { letter-spacing: 0em; }
          .cls-24 { letter-spacing: 0em; }
          .cls-25 { letter-spacing: .02em; }
        `}
      </style>
    </defs>

    <rect className="cls-9" x="38.02" y="20.05" width="273.32" height="112.94" />
    <rect className="cls-14" x="311.34" y="20.05" width="273.32" height="112.94" />
    <rect className="cls-11" x="584.66" y="20.05" width="273.32" height="112.94" />
    <rect className="cls-8" x="857.97" y="20.05" width="273.32" height="112.94" />

    <g className="cls-15">
      <text className="cls-1" transform="translate(121.8 84.97)">Outpost</text>
    </g>
    <g className="cls-15">
      <text className="cls-1" transform="translate(396.68 87.44)">
        <tspan x="0" y="0">Sa</tspan>
        <tspan className="cls-20" x="33.95" y="0">t</tspan>
        <tspan className="cls-16" x="42.84" y="0">elli</tspan>
        <tspan className="cls-20" x="77.76" y="0">t</tspan>
        <tspan x="86.64" y="0">e</tspan>
      </text>
    </g>
    <text className="cls-1" transform="translate(636.57 87.44)">
      <tspan className="cls-19" x="0" y="0">P</tspan>
      <tspan x="17.15" y="0">o</tspan>
      <tspan className="cls-25" x="33.6" y="0">r</tspan>
      <tspan x="43.91" y="0">t</tspan>
      <tspan className="cls-21" x="53.25" y="0">f</tspan>
      <tspan x="61.15" y="0">olio Hub</tspan>
    </text>
    <text className="cls-3" transform="translate(867.47 87.44)">
      <tspan className="cls-18" x="0" y="0">T</tspan>
      <tspan className="cls-23" x="14.53" y="0">r</tspan>
      <tspan x="23.78" y="0">ans</tspan>
      <tspan className="cls-21" x="70.1" y="0">f</tspan>
      <tspan x="78" y="0">ormation Hub</tspan>
    </text>

    {/* Connector arrows and lines */}
    <g>
      <line className="cls-7" x1="584.66" y1="171.58" x2="584.66" y2="173.58" />
      <line className="cls-10" x1="584.66" y1="178.2" x2="584.66" y2="194.37" />
      <polyline className="cls-7" points="584.66 196.68 584.66 198.68 586.66 198.68" />
      <line className="cls-13" x1="590.68" y1="198.68" x2="853.96" y2="198.68" />
      <polyline className="cls-7" points="855.97 198.68 857.97 198.68 857.97 196.68" />
      <line className="cls-10" x1="857.97" y1="192.06" x2="857.97" y2="175.89" />
      <line className="cls-7" x1="857.97" y1="173.58" x2="857.97" y2="171.58" />
    </g>

    {/* Arrow down */}
    <line className="cls-12" x1="721.32" y1="227.39" x2="721.32" y2="201.68" />
    <polygon className="cls-4" points="712.64 227.92 721.32 239.48 729.99 227.92 712.64 227.92" />

    {/* Number markers */}
    <text className="cls-6" transform="translate(30.94 162.07)">1</text>
    <text className="cls-6" transform="translate(302.68 162.07)">2</text>
    <text className="cls-6" transform="translate(575.61 162.07)">3</text>
    <text className="cls-6" transform="translate(848.68 162.07)">4</text>
    <text className="cls-6" transform="translate(1122.32 162.07)">5</text>

    {/* Bottom text labels */}
    <text className="cls-2" transform="translate(584.34 282.33)">
      <tspan x="70" y="0">{company}</tspan>
    </text>
    <text className="cls-2" transform="translate(631.44 319.18)">
      <tspan x="-10" y="0">Maturity Index: {score}</tspan>
    </text>
  </svg>
);

export default SvgWithLabels;
